module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.statementRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-0 pl-0 overline",
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.statementRequest.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getStatement.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    " + _vm._s(_vm.$tc('appointmentsselected', _vm.numAppointments, {
    count: _vm.numAppointments
  })) + "\n    "), _c('v-spacer'), _vm._v(" "), (_vm.collapsed) ? _c('v-icon', [_vm._v("expand_more")]) : _c('v-icon', [_vm._v("expand_less")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [(!_vm.collapsed) ? [_vm._l((_vm.statementAppointments), function(appointment) {
    return [_c('appointment-list-item', {
      key: appointment.id,
      attrs: {
        "with-status-chips": "",
        "appointment": appointment,
        "with-action": false
      }
    }, [_c('template', {
      slot: "action"
    }, [(_vm.withEdit) ? _c('v-list-tile-action', [_c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('edit', appointment)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), (appointment.financials) ? _c('v-list-tile-action', {
      staticClass: "subheading"
    }, [_c('span', {
      staticClass: "mt-3"
    }, [_vm._v("\n                " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.final_due)) + "\n              ")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("Due")])], 1) : _vm._e()], 1)], 2), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (appointment.id))
    })]
  })] : _vm._e(), _vm._v(" "), (_vm.withTotals && _vm.totalDue !== null) ? [_c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline py-0 py-0"
  }, [_vm._v("Totals")]), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pb-5"
  }, [(_vm.totalDue > 0) ? _vm._t("list-tile") : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "subheading"
  }, [(_vm.appointmentPrice && parseFloat(_vm.appointmentPrice) > 0) ? _c('v-list-tile-action-text', [_vm._v("\n              appointments: " + _vm._s(_vm.formatCurrency(_vm.currency, _vm.appointmentPrice)) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.discounts && parseFloat(_vm.discounts) > 0) ? _c('v-list-tile-action-text', [_vm._v("\n              product sales: " + _vm._s(_vm.formatCurrency(_vm.currency, _vm.productSales)) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.discounts && parseFloat(_vm.discounts) > 0) ? _c('v-list-tile-action-text', [_vm._v("\n              discounts: " + _vm._s(_vm.formatCurrency(_vm.currency, _vm.discounts)) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.totalPaid && parseFloat(_vm.totalPaid) > 0) ? _c('v-list-tile-action-text', [_vm._v("\n              payments: " + _vm._s(_vm.formatCurrency(_vm.currency, _vm.totalPaid)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "mt-1"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.currency, _vm.totalDue)))]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("outstanding")])], 1)], 2), _vm._v(" "), _vm._t("list-end")] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e287902","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/ReadOnlyStatementList.vue
// module id = 1372
// module chunks = 9